import { sharedMessages } from '@/lang/shared/messages'

export const kihnuMessages = {
  ...sharedMessages,
  headerContactsLabel: {
    id: 'header.contacts-label',
    defaultMessage: 'Contacts',
    description: 'Contacts section label in the mobile header menu',
  },
  headerLanguageLabel: {
    id: 'header.language-label',
    defaultMessage: 'Language',
    description: 'Language section label in the mobile header menu',
  },
  footerContactsTitle: {
    id: 'footer.contacts-title',
    defaultMessage: 'Contacts',
    description: 'Contacts column title in the footer',
  },
  footerCustomerServiceLabel: {
    id: 'footer.customer-service-label',
    defaultMessage: 'Customer service',
    description: 'Customer service phone label in the footer',
  },
  footerEmailLabel: {
    id: 'footer.email-label',
    defaultMessage: 'E-mail',
    description: 'Email label in the footer',
  },
  footerRegNoLabel: {
    id: 'footer.reg-no-label',
    defaultMessage: 'Reg. no.',
    description: 'Company registration number label in the footer',
  },
  footerVatLabel: {
    id: 'footer.vat-label',
    defaultMessage: 'VAT',
    description: 'VAT number label in the footer',
  },
  vehicleLookupPending: {
    id: 'vehicleLookupPending',
    defaultMessage: 'Checking the Transport Administration register…',
    description: 'Status shown while the vehicle registry lookup is in progress',
  },
  vehicleLookupRequestError: {
    id: 'vehicleLookupRequestError',
    defaultMessage: 'Unable to check the registration number. Please try again.',
    description: 'Shown when the vehicle lookup request itself fails before returning a backend response',
  },
  vehicleLookupNotFound: {
    id: 'vehicleLookupNotFound',
    defaultMessage:
      "Sorry! This registration number was not found. Please continue by entering your vehicle's details manually.",
    description: 'Shown when the vehicle registry lookup found no matching ticket type',
  },
  vehicleLookupRegisterDown: {
    id: 'vehicleLookupRegisterDown',
    defaultMessage: 'The vehicle registry is unavailable. Please fill in the details manually below.',
    description: 'Shown when the vehicle registry is unreachable',
  },
  vehicleWrongForm: {
    id: 'vehicleWrongForm',
    defaultMessage: 'NB! This is a trailer number — please use the Trailer card.',
    description: 'Shown on the vehicle card when the entered plate belongs to a trailer',
  },
  trailerWrongForm: {
    id: 'trailerWrongForm',
    defaultMessage: 'NB! This is a vehicle number — please use the Vehicle card.',
    description: 'Shown on the trailer card when the entered plate belongs to a vehicle',
  },
  vehicleLookupGenericError: {
    id: 'vehicleLookupGenericError',
    defaultMessage: 'Vehicle check failed. Please fill in the details manually below.',
    description: 'Fallback error shown when the vehicle registry lookup fails for an unknown reason',
  },
  vehicleNewWeightLabel: {
    id: 'vehicleNewWeightLabel',
    defaultMessage: 'New weight',
    description: 'Label of the field that corrects the register gross weight of a heavy vehicle',
  },
  vehicleWeightUnit: {
    id: 'vehicleWeightUnit',
    defaultMessage: 'kg',
    description: 'Unit shown beside the gross weight field',
  },
  vehicleWeightChange: {
    id: 'vehicleWeightChange',
    defaultMessage: 'Change weight',
    description: 'Button that opens the gross weight correction inside the registry panel',
  },
  vehicleWeightSave: {
    id: 'vehicleWeightSave',
    defaultMessage: 'Save weight',
    description: 'Button that keeps the corrected gross weight in the form',
  },
  vehicleWeightDiscard: {
    id: 'vehicleWeightDiscard',
    defaultMessage: 'Discard',
    description: 'Button that drops the gross weight being typed and closes the correction',
  },
  vehicleWeightBelowCurb: {
    id: 'vehicleWeightBelowCurb',
    defaultMessage: 'The weight cannot be lower than the kerb mass of {weight} kg',
    description: 'Validation message when the corrected gross weight is below the register kerb mass',
  },
  vehicleWeightCorrected: {
    id: 'vehicleWeightCorrected',
    defaultMessage: 'Weight corrected to {weight} kg. The registered figure was {registryWeight} kg.',
    description: 'Confirmation line stating both the corrected and the registered gross weight',
  },
  vehiclePlateHelper: {
    id: 'vehiclePlateHelper',
    defaultMessage:
      'The Estonian Transport Administration provides current data about your vehicle based on its registration number.',
    description: 'First paragraph of the helper text below the registration plate field',
  },
  vehiclePlateHelperFallback: {
    id: 'vehiclePlateHelperFallback',
    defaultMessage: "If no data is found, you can enter your vehicle's details yourself in the form below.",
    description:
      'Second paragraph of the helper text below the plate field: what happens when the registry has no data',
  },
  vehicleFoundInRegistry: {
    id: 'vehicleFoundInRegistry',
    defaultMessage: 'Data provided by the Transport Administration:',
    description: 'Header of the panel listing the vehicle data returned by the registry lookup',
  },
  vehiclePriceCalculationError: {
    id: 'vehiclePriceCalculationError',
    defaultMessage: 'Unable to calculate the ticket price. Please try again.',
    description: 'Inline error shown when the manual vehicle price preview request fails',
  },
  vehicleCompanyCodeLabel: {
    id: 'vehicleCompanyCodeLabel',
    defaultMessage: 'Company registration number',
    description: 'Label of the optional company registration code field (contract discount)',
  },
  vehicleCompanyCodePlaceholder: {
    id: 'vehicleCompanyCodePlaceholder',
    defaultMessage: 'e.g. 10254876',
    description: 'Placeholder of the company registration code field',
  },
  vehicleAccessibleTitle: {
    id: 'vehicleAccessibleTitle',
    defaultMessage:
      'Vehicle transporting a person with a profound disability, a person with a profound visual impairment, or a disabled child',
    description: 'Title of the disability-exemption checkbox',
  },
  vehicleCompanyDiscountApplied: {
    id: 'vehicleCompanyDiscountApplied',
    defaultMessage: 'Company discount applied.',
    description: 'Shown when the sailing priced the vehicle as company-owned',
  },
  vehicleCompanyDiscountNotFound: {
    id: 'vehicleCompanyDiscountNotFound',
    defaultMessage: 'No company discount for this registration number.',
    description: 'Shown when the company code brought no discount',
  },
  vehicleCompanyCheckFailed: {
    id: 'vehicleCompanyCheckFailed',
    defaultMessage: 'Could not check the business register. Try again.',
    description: 'Shown when the business register could not be reached or the check request failed',
  },
  vehicleAccessibleUnavailableOnSail: {
    id: 'vehicleAccessibleUnavailableOnSail',
    defaultMessage: 'This exemption is not available on this sailing.',
    description: 'Shown when the sailing refuses the disability exemption for the checked plate',
  },
  vehicleAccessibleCheckFailed: {
    id: 'vehicleAccessibleCheckFailed',
    defaultMessage: 'Unable to check this exemption. Please try again.',
    description: 'Shown next to the disability exemption when its price check fails',
  },
  vehicleElevatedTariff: {
    id: 'vehicleElevatedTariff',
    defaultMessage: 'An elevated tariff applies to carrying a vehicle on this sailing.',
    description:
      'Fallback shown when the sailing applied an elevated tariff but the route has no text for the condition',
  },
  vehicleCompanyCodeHint: {
    id: 'vehicleCompanyCodeHint',
    defaultMessage: 'If the vehicle is owned by a company, fill in its registration number.',
    description: 'Hint under the company registration code label',
  },
  vehicleDelete: {
    id: 'vehicleDelete',
    defaultMessage: 'Delete',
    description: 'Visible label of the destructive button in the vehicle/trailer form footer',
  },
  vehicleDeleteTicket: {
    id: 'vehicleDeleteTicket',
    defaultMessage: 'Delete vehicle',
    description: 'Accessible name of the vehicle Delete button, which reads only "Delete" on screen',
  },
  trailerDeleteTicket: {
    id: 'trailerDeleteTicket',
    defaultMessage: 'Delete trailer',
    description: 'Accessible name of the trailer Delete button, which reads only "Delete" on screen',
  },
  customerInformationPhoneCode: {
    id: 'customerInformationPhoneCode',
    defaultMessage: 'Country code',
    description: 'Accessible name of the country-code input, which shares its legend with the phone number',
  },
  customerInformationContactHint: {
    id: 'customerInformationContactHint',
    defaultMessage: 'The ticket confirmation and any schedule changes are sent to this address and phone number.',
    description: 'Explains what the contact details on the contact-info tab are used for',
  },
  editPaymentCancelledNotice: {
    id: 'edit-reservation.payment-cancelled-notice',
    defaultMessage: 'The payment was cancelled. Your changes have not been applied.',
    description: 'Notice on the edit page after the user cancelled the additional payment at the payment provider',
  },
}
